import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

/** Indicatore di giacenza della nuova UI della vetrina: cerchio colorato per stato, con la quantità in una pillola quando disponibile. */
@Component({
    selector: "app-showcase-stock-badge",
    standalone: true,
    imports: [NgClass, MatIconModule],
    host: { class: 'tw-ml-auto tw-block tw-w-fit tw-min-w-0 tw-max-w-full' },
    template: `
        @if (status !== 'stock-disabled') {
            <span class="tw-flex tw-min-w-0 tw-max-w-full tw-items-center tw-justify-end tw-gap-1 tw-rounded-[28px] tw-border tw-border-solid tw-p-[2px]"
                  [ngClass]="hasQuantity ? color.border : 'tw-border-transparent !tw-p-0'">
                @if (hasQuantity) {
                    <span class="tw-min-w-0 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-xs tw-leading-none
                        tw-pl-1">@if (quantity! > 0) {<span class="tw-inline-block tw--translate-y-[1px]">+</span>}{{ quantity }}</span>
                }
                <span class="tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-text-white" [ngClass]="color.bg">
                    <mat-icon class="tw-h-[18px] tw-w-[18px] tw-text-[18px] tw-leading-[18px]">add</mat-icon>
                </span>
            </span>
        }
    `
})
export class ShowcaseStockBadgeComponent {
    @Input() status = 'stock-disabled';
    @Input() quantity?: number | null;

    protected get hasQuantity(): boolean {
        return this.quantity !== undefined && this.quantity !== null;
    }

    protected get color(): { bg: string, border: string } {
        switch (this.status) {
            case 'stock-info-available': return { bg: 'tw-bg-[#8bc34a]', border: 'tw-border-[#8bc34a]' };
            case 'stock-info-alert': return { bg: 'tw-bg-[#ffc107]', border: 'tw-border-[#ffc107]' };
            case 'stock-info-unavailable': return { bg: 'tw-bg-[#ff5252]', border: 'tw-border-[#ff5252]' };
            default: return { bg: 'tw-bg-[#1a73e8]', border: 'tw-border-[#1a73e8]' };
        }
    }
}
